import request from "@/utils/request";

export default function getFileSignUrl(filepath) {
    return request({
        url: `/common/adminGetFileSignURL`,
        method: 'post',
        data: {filepath: filepath}
    })
}
